import $ from 'jQuery';
import './machine_app_modal.css';

export const modal = ({ onClose = undefined, closeOnOutsideClick = false, appendElement = 'body' } = {}) => {
  const lModalContainer = $('<div>').addClass('machineapp_component_modal_container');
  const lModalContent = $('<div>').addClass('machineapp_component_modal_content');

  lModalContainer.append(
    lModalContent,
  );

  const show = () => $(appendElement).append(lModalContainer);
  const hide = () => {
    lModalContainer.detach();

    if (onClose) {
      onClose();
    }
  };

  if (closeOnOutsideClick) {
    lModalContent.on('click', e => e.stopPropagation());
    lModalContainer.one('click', hide);
  }

  return {
    show,
    hide,
    content: lModalContent
  };
};
